// Author YuJiaBei
// Date 2021-12-15 15:27:48

import * as model from "@/model/em/repair/RepairPlanDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.RepairPlanDetail(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_REPAIR_URL,
    })
    .buildStore()
